import { render, staticRenderFns } from "./yc-profit.vue?vue&type=template&id=0501fb06&scoped=true&"
import script from "./yc-profit.vue?vue&type=script&lang=js&"
export * from "./yc-profit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0501fb06",
  null
  
)

export default component.exports